"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateConfiguration = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Default configuration structure
var currentConfiguration = {
  styles: {
    namespace: null
  }
};

var updateConfiguration = function updateConfiguration(newValues) {
  currentConfiguration = (0, _extends3.default)({}, currentConfiguration, newValues);
};

// Add a way to set the configuration without a knowledge of this package.
// We need this, because sometimes we don't have access to the actual wel
// context.
if (global.welUiConfig) {
  updateConfiguration(global.welUiConfig);
}

exports.default = {
  get current() {
    return currentConfiguration;
  }
};
exports.updateConfiguration = updateConfiguration;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wel-ui/utility-configuration/lib/index.js
// module id = 131
// module chunks = 0